import React, { useMemo } from "react";

import {
  IActiveLearningIssue,
  IActiveLearningQuestion,
} from "../../../../../../state";
import Selector from "../../../../../../atoms/ActiveLearning/Selector";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import styles from "../../../ActiveLearningIssue.module.scss";
import hintImage07 from "../../../../../../assets/images/ActiveLearning/hint/img_07.webp";
import hintImage08 from "../../../../../../assets/images/ActiveLearning/hint/img_08.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  const question3 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 3);
  }, [props.issue?.questions]);

  const answerData: {
    question: IActiveLearningQuestion | undefined;
  }[] = [
    {
      question: question1,
    },
    {
      question: question2,
    },
    {
      question: question3,
    },
  ];

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          前回のLessonでは「問い」に答えを出す道のりで生まれる問題を思いつく限り予測した。
          <br />
          ヒント①を参考にして、考えた問題の中から｢これを取り除けば実現への近道になりそう。｣と思えるものを、3つまで選ぼう。
          <br />
          次に、ヒント②を参考にして、選んだ問題の原因について調べよう。
        </p>
      </div>
      {answerData.map((data, index) => (
        <div key={`question${index}`} className={styles.tree}>
          {data.question && (
            <>
              <Selector />
              <ul className={styles.branchList}>
                <li className={styles.branch}>
                  <div className={styles.labelWrapper}>
                    <span className={styles.label}>原因</span>
                  </div>
                  <div className={styles.inputField}>
                    <TextInput />
                  </div>
                </li>
                <li className={styles.branch}>
                  <div className={styles.labelWrapper}>
                    <span className={styles.label}>調べたこと</span>
                  </div>
                  <div className={styles.inputField}>
                    <TextArea />
                  </div>
                </li>
              </ul>
            </>
          )}
        </div>
      ))}
      <img src={hintImage07} alt="ヒント① 問題を選ぶためのヒント" />
      <img src={hintImage08} alt="ヒント② 原因を考えるためのヒント" />
    </div>
  );
};
export default Issue1Material;
